<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-target-operator">
    <el-select
      ref="operatorDropdown"
      v-model="targetData.operator"
      collapse-tags
      size="mini"
      style="margin-left: 5px;"
      :class="(targetData.value!=null&&targetData.value!=''&&targetData.operator=='-'?'has-error':'')"
      popper-class="operator-type"
      @change="operatorChanged"
      @visible-change="visibleChanged"
      :popper-append-to-body="false">
        <el-option
          v-for="(item) in operatorTypes"
          :key="item.key"
          :label="item.label"
          :value="item.key">
          <span style="align-text: center">{{ item.fullLabel }}</span>
        </el-option>
    </el-select>
  </div>
</template>
<script>
  export default {
    name: 'wy-target-operator',
    props: ['controller', 'operator', 'targetData'],
    data() {
      return {  
        selectedOperator: '-',
        operatorTypes: [
          {
            key: '-',
            label: 'Select rule',
            fullLabel: 'Select rule'
          },
          {
            key: '>',
            label: '>',
            fullLabel: '> (greater than)'
          },
          {
            key: '<',
            label: '<',
            fullLabel: '< (less than)'
          },
          {
            key: '=',
            label: '=',
            fullLabel: '= (equal to)'
          },
          {
            key: '<=',
            label: '≤',
            fullLabel: '≤ (less than or equal to)'
          },
          {
            key: '>=',
            label: '≥',
            fullLabel: '≥ (greater than or equal to)'
          }
        ]
      }
    },
    methods: {
      operatorChanged() {
        if(typeof this.controller.controller.controller.hasNoSavedChanges != 'undefined') {
          this.controller.controller.controller.hasNoSavedChanges = true
        }
        setTimeout(() => {
          if(typeof this.controller.controller.controller.hasError != 'undefined') {
            this.controller.controller.controller.hasError = document.querySelectorAll('.has-error').length > 0;
          }
        }, 200);
      },
      visibleChanged(isVisible) {
        if(isVisible) {
          this.controller.openDropdown = this;
        }
        else {
          this.controller.openDropdown = null
        }
      }
    }
  }
</script>

<style lang="scss">
.wy-target-operator {
  margin-right: 5px;
  .el-select .el-input .el-input__inner {
    border-color: #CAD2DA;
    height: 34px;
    border-width: 1px 1px 1px 1px !important;
    width: 103px;
    text-align: center;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #CAD2DA;
    border-width: 1px 1px 1px 1px !important;
    border: 1px #106FBC solid;
  }
  .el-select .el-input.is-focus .el-select__caret {
    color: #214586;
  }
  .el-select.has-error .el-input {
    border: 1px #EBAFBA solid;
    .el-input__inner {
      border-color: transparent;
    }
    .el-input.is-focus .el-input__inner {
      border-color: transparent;
    }
    input {
      background-color: #FFF4F4;
      border: 1px #EBAFBA solid;
      border-bottom: 0px;
    }
  } 
  .el-scrollbar__bar.is-vertical,.el-scrollbar__bar.is-horizontal {
    display: none;
  }
  .el-scrollbar__wrap {
    overflow: hidden;
    margin-bottom: -5px !important;
    margin-right: -10px !important;
  }
}
</style>